import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    url: String
  }
  connect() {
    // if (document.referrer) {
    //   this.element.style.display = 'block'
    // }
  }
  back() {
    console.log(document.referrer, 'document.referrer')
    if(this.urlValue) {
      Turbo.visit(this.urlValue)
    } else {
      window.history.back()
    }
  }
}
